module.exports = __webpack_public_path__ + "static/media/blog-40-4.aaa2faf6.webp";